import { Pipe, PipeTransform } from '@angular/core';
import { ProductFeeNChargeItemType } from '@src/app/features/web-submission/enums/product-fee-charge-item-type.enum';

@Pipe({
  name: 'expenseType',
})
export class ExpenseTypePipe implements PipeTransform {
  transform(value: any): string {
    switch (value) {
      case ProductFeeNChargeItemType.COMMISSION:
        return 'Commission';
      case ProductFeeNChargeItemType.HADING_FEE:
        return 'Handling Fee';
      case ProductFeeNChargeItemType.COMMISSION_GST:
        return 'Commission GST';
      case ProductFeeNChargeItemType.SECURITY_DEPOSIT:
        return 'Security Deposit';
      case ProductFeeNChargeItemType.CHATTEL_FEE:
        return 'Chattel Fee';
      case ProductFeeNChargeItemType.PROVISION_FEE:
        return 'Provision Fee';
      case ProductFeeNChargeItemType.ADVANCED_PAYMENT:
        return 'Advanced Payment';
      case ProductFeeNChargeItemType.PREMIUM:
        return 'Premium';
      default:
        return value;
    }
  }
}
